import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    systemListGet,
    systemListItemGet,
    systemListItemInsert,
    systemListItemUpdate
} from "api/menu/master-files/system-list/requests";

export const FETCH_SYSTEM_LIST_SUCCESS = "FETCH_SYSTEM_LIST_SUCCESS";
export const FETCH_SYSTEM_LIST_ITEM_SUCCESS = "FETCH_SYSTEM_LIST_ITEM_SUCCESS";

export const SYSTEM_LIST_REQUEST_LOADING = "SYSTEM_LIST_REQUEST_LOADING";
export const SYSTEM_LIST_REQUEST_ERRORS = "SYSTEM_LIST_REQUEST_ERRORS";

export const setLoading = () => ({
    type: SYSTEM_LIST_REQUEST_LOADING
});

export const fetchSystemList = () => dispatch => {
    dispatch(setLoading());
    systemListGet()
        .then(response => {
            dispatch({
                type: FETCH_SYSTEM_LIST_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SYSTEM_LIST_REQUEST_ERRORS));
        });
};

export const fetchSystemListItem = (listId, includeInactive = true) => dispatch => {
    dispatch(setLoading());
    systemListItemGet(listId, includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_SYSTEM_LIST_ITEM_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SYSTEM_LIST_REQUEST_ERRORS));
        });
};

export const insertSystemItem = (listId, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    systemListItemInsert(listId, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new System List "${data.itemCode}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateSystemItem = (listId, itemId, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    systemListItemUpdate(listId, itemId, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`System List "${data.itemCode}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const clearSystemList = () => dispatch => {
    dispatch({
        type: FETCH_SYSTEM_LIST_SUCCESS,
        payload: []
    });
};

export const clearSystemListItem = () => dispatch => {
    dispatch({
        type: FETCH_SYSTEM_LIST_ITEM_SUCCESS,
        payload: []
    });
};
